
import './contact.css';
import LinkedinIcon from '../../assets/linkedin-icon.png';
import GithubIcon from '../../assets/github-icon.png';
import WhatsappIcon from '../../assets/whatsapp-icon.png';
import DiscordIcon from '../../assets/discord-icon.png';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';



const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_o8t2qwe', 'template_4wsmjgf', form.current, 'PwcJfkdqTsuHgDmrK')
      .then((result) => {
        console.log(result.text);
        // Muestra la alerta de SweetAlert2 después de un envío exitoso
        Swal.fire({
          title: 'Success!',
          text: 'Your message has been sent successfully.',
          color: '#ffffff',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#555', // Color gris para el botón OK
          background: '#404040', // Fondo negro
          customClass: {
            title: 'white-text', // Texto del título en blanco
            htmlContainer: 'white-text', // Texto del cuerpo en blanco
            confirmButton: 'custom-confirm-button' // Clase personalizada para el botón OK
          },
          onOpen: (modalElement) => {
            const confirmButton = modalElement.querySelector('.custom-confirm-button');
            if (confirmButton) {
              // Aplicar estilos personalizados
              confirmButton.style.backgroundColor = '##404040'; // Color de fondo amarillo
              confirmButton.style.color = '#fff'; // Color del texto blanco
              confirmButton.style.border = '1px solid #ffc730'; // Color del borde amarillo
            }
          },
        });
        
        // Restablece el formulario
        form.current.reset();
      })
      .catch((error) => {
        console.log(error.text);
        // En caso de error, también puedes mostrar una alerta de error
        Swal.fire({
          title: 'Error!',
          text: 'Your message could not be sent. Please try again later.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      });
  };
  
  return (
    <section id='contactPage'>
      <div id='contact'>
        <h1 className='contactPageTitle'>Contact Me</h1>
        <span className='contactDesc'>Please fill out the form below to discuss any work opportunities.</span>
        <form className='contactForm' ref={form} onSubmit={sendEmail}>
          <input type='text' className='name' placeholder='Your Name' name='your_name' />
          <input type='email' className='email' placeholder='Your Email' name='your_email' />
          <textarea className='msg' name='message' rows='5' placeholder='Your Message'></textarea>
          <button type='submit' value='send' className='submitBtn'>Submit</button>
          <div className='links'>
                    <a href="https://www.linkedin.com/in/martin-dotto/"><img src={LinkedinIcon} alt='Linkedin' className='link'/></a>
                    <a href="https://api.whatsapp.com/send?phone=543513871701"><img src={WhatsappIcon} alt='Whatsapp' className='link'/></a>
                    <a href="https://discord.gg/qpvJu4j6"><img src={DiscordIcon} alt='Discord' className='link'/></a>
                    <a href="https://github.com/tinchila"><img src={GithubIcon} alt='Github' className='link'/></a>
                </div>
            </form>
        </div>
    </section>
  )
}

export default Contact
